module.exports = __webpack_public_path__ + "static/media/logo_kidsmatin_mobile.58aea1c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/logo_kidsmatin_mobile.svg
// module id = 320
// module chunks = 0